import Image from "next/image"

import { useTailwindBreakpoints } from "components/hooks/use-tailwind-breakpoints"

import { Box } from "components/shared/box"
import { Text } from "components/shared/text"

export type StatItemData = {
  imgUrl?: string
  label: string
  value: string | number
}

export type StatItemProps = StatItemData & {
  uppercase?: boolean
  mb?: string
}

export function StatItem({ imgUrl, label, value, uppercase, mb = "mb-4" }: StatItemProps) {
  const { isMobile } = useTailwindBreakpoints()
  return (
    <Box row className={`justify-between items-center w-full ${mb}`}>
      <Box row className="gap-1 items-center lg:gap-4">
        {imgUrl && <Image src={imgUrl} width={isMobile ? 16 : 40} height={isMobile ? 16 : 40} alt="stat image" />}
        <Text
          size={isMobile ? "tiny" : "lg"}
          weight="bold"
          className={`text-[#A9A1FF] ${uppercase && "uppercase"} whitespace-nowrap mr-1`}
        >
          {label}
        </Text>
      </Box>
      <Text size={isMobile ? "sm" : "lg"} weight="bold" className="mr-12 lg:mr-0">
        {value}
      </Text>
    </Box>
  )
}
